import { LocalesType } from 'components/TranslatorPopover'
import { ICompanyConfig } from 'interfaces/company.interface'
import {
  MachineryEnum,
  MachineryPurpose,
  MachineryUse,
} from 'interfaces/machinery.interface'
import { flatten } from 'lodash'
import { enumToArray } from 'utils/enum-to-array'
import { colors } from './colors'
import uses from './use.json'
import countriesStates from './countries-states-iso3166-slim.json'
import { bikeColors } from 'ai-constants'

export type CountryType = (typeof countriesStates)[number]

export type StateType = (typeof countriesStates)[number]['states'][number]

export const staticInputsOptions = {
  locale: (input: { config: ICompanyConfig }): LocalesType[] =>
    input.config.locales,
  delivery: {
    channel: ['email', 'sms', 'own', 'wsp'],
    countryISO: countriesStates,
  },
  car: {
    color: colors,
    use: uses,
  },
  moto: {
    color: colors,
    use: uses,
  },
  machinery: {
    type: enumToArray(MachineryEnum),
    use: enumToArray(MachineryUse),
    purpose: enumToArray(MachineryPurpose),
    color: colors,
  },
  consumer: {
    state: flatten(countriesStates.map((country) => country.states)),
    country: countriesStates,
    sex: ['male', 'female', 'not_applicable'],
  },
  bike: {
    color: bikeColors,
  },
} as const
